function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), React.createElement("path", {
  d: "M18.035 6.25c-3.241-3.241-8.545-3.241-11.785 0-3.241 3.24-3.241 8.544 0 11.785 3.24 3.24 8.544 3.24 11.785 0 3.24-3.241 3.24-8.545 0-11.786zm-3.536 9.428l-2.357-2.357-2.357 2.357-1.178-1.179 2.357-2.357-2.357-2.357 1.178-1.178 2.357 2.357L14.5 8.607l1.179 1.178-2.357 2.357 2.357 2.357-1.179 1.179z",
  fill: "#999"
})));